// assets
import { TableOutlined, BgColorsOutlined, FontSizeOutlined, UserOutlined, HistoryOutlined } from '@ant-design/icons';

// icons
const icons = {
  FontSizeOutlined,
  BgColorsOutlined,
  TableOutlined,
  UserOutlined,
  HistoryOutlined
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities = {
  id: 'accountpages',
  title: 'Account Pages',
  type: 'group',
  children: [
    {
      id: 'whitelist',
      title: 'Whitelist',
      type: 'item',
      url: '/whitelist',
      icon: icons.FontSizeOutlined
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item',
      url: '/profile',
      icon: icons.UserOutlined
    },
    {
      id: 'account',
      title: 'Account',
      type: 'item',
      url: '/account',
      icon: icons.TableOutlined
    },
    {
      id: 'log',
      title: 'Log',
      type: 'item',
      url: '/log',
      icon: icons.HistoryOutlined
    }
  ]
};

export default utilities;
